// --------------------------------------------- [START] 關鍵字篩選接API
// 使用Ajax Autocomplete for jQuery (Authors: Tomas Kirda)
// https://github.com/devbridge/jQuery-Autocomplete
(function(window, document) {

	function buildAutocomplete() {
		var searchInput = $('#searchMain');
		var searchForm = searchInput.closest('form');
	
		searchInput.autocomplete({
			maxHeight: 320,
			lookup: function (query, done) {
				// 套程式用
				var url = `/api/showKeywords?query=${query}`;

				// 測試站用
				// var url = `/json/search-keyword.json`;

				$.ajax({
					url: url,
					type: 'GET',
					error: function(xhr) {
						console.log('Ajax request 發生錯誤', xhr);
					},
					success: function(response) {
						var result = response.result;
						if (result.length > 0) {
							// 套程式用
							var max = result.length;

							// 測試站用
							// var max = Math.floor(Math.random() * 10);

							var resultList = {
								suggestions: []
							};
							for (var i = 0; i < max; i++) {
								resultList.suggestions.push({value: result[i]})
							}

							done(resultList);
						}
					}
				})
			},
			onSelect: function (suggestion) {
				searchForm.submit();
			}
		});
	}

	registerListener('load', buildAutocomplete)

})(window, document);
// --------------------------------------------- [END] 關鍵字篩選接API
